import { type CommercialReceptionReasonEntity } from "@/features/commercialRegistrationMonitoring/types";

export const getDisplayReceptionReason = (
  receptionReasons: CommercialReceptionReasonEntity[],
  separator = " / "
): string => {
  return [...receptionReasons]
    .sort((a, b) => a.id - b.id)
    .map((receptionReason) => receptionReason.name)
    .join(separator);
};
